import React from "react";
import { Link } from "@reach/router";
import styled from "styled-components";
//
import { RichText } from "components/prismic";
import Image from "components/image";
//
export default ({ items, long_title, pictogram, text, title, ...rest }) => (
  <Wrap>
    <Items>
      <Back>
        <Link to="/toiminta" title="Takaisin">
          &#12296; Takaisin
        </Link>
      </Back>
      <Picrogam>
        <img src={pictogram.url} alt={title} />
      </Picrogam>
      <Item>
        <Title>{long_title}</Title>
        {text && (
          <Text>
            <RichText {...text} />
          </Text>
        )}
      </Item>
    </Items>
    <List>{items && items.map((item, i) => <Image key={i} {...item} />)}</List>
  </Wrap>
);
//
const Wrap = styled.div`
  margin: 0 auto;
  max-width: 1350px;
  min-height: 100vh;
  min-height: calc(100vh - 136px - 320px);
  padding: 2rem 0;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;
const Items = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0.5rem;
  padding: 0.5rem;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 2rem;
    margin: auto;
    padding: 1.5rem;
    width: 100%;
  }
`;
const Back = styled.div`
  padding-bottom: 1rem;
  text-transform: uppercase;

  @media (min-width: 768px) {
    padding: 0;
`;
const Picrogam = styled.div`
  display: grid;
  grid-row-start: 2;
  overflow: hidden;
  vertical-align: top;
  height: auto;
  position: relative;
  margin: 0 0 20px;
  max-width: 100%;

  img {
    max-height: 50vh;
    justify-self: center;
    padding: 1vh 4vw;

    @media (min-width: 768px) {
      justify-self: end;
    }

    @media (min-width: 992px) {
      padding: 0 3vw;
    }
  }
`;
const Item = styled.div`
  grid-row-start: 2;
`;
const Title = styled.h2`
  font-size: 1.5em;
  font-weight: normal;
  margin: 0;
  text-transform: uppercase;
`;

const Text = styled.div`
  @media (min-width: 1040px) {
    padding-right: 5rem;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 1.5rem;
  width: 95vw;

  @media (min-width: 768px) {
    width: 40vw;
  }

  @media (min-width: 2160px) {
    width: 20vw;
  }
`;
